import { Link } from 'react-router-dom'

import styles from './SurveysTableTitle.module.scss'


type Props = {
  surveyId: string
  title: string
}

export const SurveysTableTitle = ({ surveyId, title }: Props) => (
  <Link className={styles.link} to={`/surveys/${surveyId}`}>
    {title}
  </Link>
)
